<template>
  <div class="container g-flex g-row-center">
    <div class="total-width g-flex g-col-top g-m-t-30">
      <!--   试卷   -->
      <div class="test-paper">
        <div class="total-padding" v-loading="loading">
          <div class="questions" v-for="(item,index) in dataList" :key="index">
            <!--   大题标题   -->
            <div class="g-p-t-30 g-flex">
              <p class="g-font-22 g-weight-font">{{ item.label }}</p>
              <p class="g-font-18 sub-text">{{ item.subLabel }}</p>
            </div>

            <!--   单选题类型   -->
            <div v-if="item.questionType*1 === 1">
              <div class="g-m-l-15" v-for="(sub,subIndex) in item.questionList" :key="subIndex">
                <p class="g-m-t-25 g-p-b-10 g-font-16 g-weight-font question-content" v-html="subIndex+1+'. '+sub.questionContent"/>
                <div class="g-m-l-20">
                  <el-radio-group v-model="sub.chooseAnswer" :disabled="isSubmit">
                    <div class="g-m-t-15 main-text g-font-14" v-for="(select,sInd) in sub.answerList" :key="sInd">
                      <el-radio  :label="select.orderCode"><p v-html="select.orderCode+'.'+select.answerContent"/></el-radio>
                    </div>
                  </el-radio-group>
                </div>
                <!--   正确答案   -->
                <div class="answer-row g-m-t-30" v-if="isSubmit">
                  <div class="g-p-15">
                    <div class="g-flex green-text" v-if="sub.isRight">
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答对了！</p>
                    </div>
                    <div class="red-text g-flex" v-else>
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答错了！</p>
                    </div>
                    <div class="g-flex g-m-t-15 g-font-14 g-weight-font">
                      <p>【我的答案】</p>
                      <p class="g-m-l-10">{{ sub.chooseAnswer }}</p>
                      <p class="g-m-l-80 g-p-l-20">【正确答案】</p>
                      <p class="g-m-l-10">{{ sub.rightAnswers }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--   多选题类型   -->
            <div v-if="item.questionType*1 === 2">
              <div class="g-m-l-15" v-for="(sub,subIndex) in item.questionList" :key="subIndex">
                <p class="g-m-t-25 g-p-b-10 g-font-16 g-weight-font question-content"  v-html="subIndex+1+'. '+sub.questionContent"></p>
                <div class="g-m-l-20">
                  <el-checkbox-group v-model="sub.chooseAnswer" :disabled="isSubmit">
                    <div class="g-m-t-15 main-text g-font-14" v-for="(select,sInd) in sub.answerList" :key="sInd">
                      <el-checkbox :label="select.orderCode"><p v-html="select.orderCode+'.'+select.answerContent"/></el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <!--   正确答案   -->
                <div class="answer-row g-m-t-30" v-if="isSubmit">
                  <div class="g-p-15">
                    <div class="g-flex green-text" v-if="sub.isRight">
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答对了！</p>
                    </div>
                    <div class="red-text g-flex" v-else>
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答错了！</p>
                    </div>
                    <div class="g-flex g-m-t-15 g-font-14 g-weight-font">
                      <p>【我的答案】</p>
                      <p class="g-m-l-10">{{ sub.chooseAnswer }}</p>
                      <p class="g-m-l-80 g-p-l-20">【正确答案】</p>
                      <p class="g-m-l-10">{{ sub.rightAnswers }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--   判断题类型   -->
            <div v-if="item.questionType*1 === 3">
              <div class="g-m-l-15" v-for="(sub,subIndex) in item.questionList" :key="subIndex">
                <p class="g-m-t-25 g-p-b-10 g-font-16 g-weight-font question-content" v-html="subIndex+1+'. '+sub.questionContent"/>
                <div class="g-m-l-20">
                  <el-radio-group v-model="sub.chooseAnswer" :disabled="isSubmit">
                    <div class="g-m-t-15 main-text g-font-14" v-for="(select,sInd) in sub.answerList" :key="sInd">
                      <el-radio :label="select.orderCode"><p v-html="select.orderCode+'.'+select.answerContent"/></el-radio>
                    </div>
                  </el-radio-group>
                </div>
                <!--   正确答案   -->
                <div class="answer-row g-m-t-30" v-if="isSubmit">
                  <div class="g-p-15">
                    <div class="g-flex green-text" v-if="sub.isRight">
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答对了！</p>
                    </div>
                    <div class="red-text g-flex" v-else>
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答错了！</p>
                    </div>
                    <div class="g-flex g-m-t-15 g-font-14 g-weight-font">
                      <p>【我的答案】</p>
                      <p class="g-m-l-10">{{ sub.chooseAnswer }}</p>
                      <p class="g-m-l-80 g-p-l-20">【正确答案】</p>
                      <p class="g-m-l-10">{{ sub.rightAnswers }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--   填空题类型   -->
            <div v-if="item.questionType*1 === 4">
              <div class="g-m-l-15" v-for="(sub,subIndex) in item.questionList" :key="subIndex">
                <p class="g-m-t-25 g-p-b-10 g-font-16 g-weight-font question-content" v-html="subIndex+1+'. '+sub.questionContent"/>
                <div class="g-m-t-10 inputs g-m-l-20" v-for="(inputs,ind) in sub.answerList" :key="ind">
                  <el-input :disabled="isSubmit" :placeholder="'请输入第'+(ind+1)+'个空的答案'"
                            v-model="inputs.value"></el-input>
                </div>

                <!--   正确答案   -->
                <div class="answer-row g-m-t-30" v-if="isSubmit">
                  <div class="g-p-15">
                    <div class="g-flex green-text" v-if="sub.isRight">
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答对了！</p>
                    </div>
                    <div class="red-text g-flex" v-else>
                      <i class="el-icon-success"></i>
                      <p class="g-m-l-10 g-font-16">答错了！</p>
                    </div>
                    <div class="g-flex g-m-t-15 g-font-14 g-weight-font">
                      <p>【我的答案】</p>
                      <p class="g-m-l-10">{{ sub.chooseAnswer }}</p>
                      <p class="g-m-l-80 g-p-l-20">【正确答案】</p>
                      <p class="g-m-l-10">{{ sub.rightAnswers }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--   底部按钮   -->
        <div class="g-flex g-row-center">
          <!--   未提交   -->
          <div class="btn" @click="doSubmit(1)" v-if="!isSubmit">
            交卷
          </div>

          <!--   合格   -->
          <div class="btn" @click="doSubmit(2)" v-if="isPassed">
            查看证书
          </div>

          <!--   不合格   -->
          <div class="btn" @click="doSubmit(3)" v-if="!isPassed">
            再次考试
          </div>
        </div>
      </div>

      <!--   右侧浮动窗   -->
      <div class="right-part g-rela g-m-l-20">
        <div class="time-window">
          <p class="g-text-center g-font-20 g-m-t-30 white-text">{{ paperQuestion.paperName }}</p>
          <div class="g-m-t-64">
            <!--   未提交 倒计时  -->
            <div v-if="!isSubmit">
              <div class="g-flex g-row-center">
                <img src="@/assets/examination/count-icon.png" class="count-icon" alt="">
                <p class="g-font-16 g-m-l-10 main-text">考试剩余时间</p>
              </div>
              <div class="count-box g-m-t-20">
                {{ timeMsg }}
              </div>
            </div>
            <!--  已提交 合格   -->
            <div class="g-rela g-p-t-20 g-p-b-20 g-text-center" v-if="isSubmit && subFinishData.isPassed">
              <p class="g-font-30 green-text">{{ subFinishData.score }}分</p>
              <img src="@/assets/examination/passed-icon.png" class="res-icon" alt="">
            </div>
            <!--  已提交 不合格   -->
            <div class="g-rela g-p-t-20 g-p-b-20 g-text-center" v-if="isSubmit && !subFinishData.isPassed">
              <p class="g-font-30 red-text">{{ subFinishData.score }}分</p>
              <img src="@/assets/examination/failed-icon.png" class="res-icon" alt="">
            </div>
            <!--  时间 | 题数 | 分数   -->
            <div class="g-flex g-row-center g-m-t-20">
              <div class="g-text-center">
                <p class="remark-text g-font-12">考试时间</p>
                <p class="g-m-t-10 green-text">{{ paperQuestion.duration }}分钟</p>
              </div>
              <div class="str-line g-m-l-25 g-m-r-25"></div>
              <div class="g-text-center">
                <p class="remark-text g-font-12">题数</p>
                <p class="g-m-t-10 green-text">{{ paperQuestion.questionNum }}题</p>
              </div>
              <div class="str-line g-m-l-25 g-m-r-25"></div>
              <div class="g-text-center">
                <p class="remark-text g-font-12">满分</p>
                <p class="g-m-t-10 green-text">{{ paperQuestion.totalScore }}分</p>
              </div>
            </div>
            <!--   考试提醒   -->
            <div class="g-m-t-26 g-m-l-30 g-m-r-30 warning-box g-font-12 warning-text">
              考试提醒：考生请注意，在考试途中请不要切换浏览器窗口或切换应用，若中途关闭浏览器窗口则视为放弃考试。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  时间结束 弹窗  -->
    <message-box ref="popup" cancelText="关闭" :show-confirm="false">
      <div class="g-m-t-10 g-text-center">
        <p class="g-font-16 main-text">考试时间已到，已强制交卷！</p>
        <p class="remark-text g-m-t-10">考试时间{{ paperQuestion.duration }}分钟，您已超时！</p>
      </div>
    </message-box>
  </div>
</template>

<script>
import messageBox from "@/components/message-popup";
import { getPaperQuestion,finishExam } from "@/api/education/paper";

export default {
  name: "written-test",
  components: {messageBox},
  data() {
    return {
      paperId: this.$route.query.paperId,
      paperQuestion: {},
      times: 2 * 60 * 60,//单位 秒
      timeMsg: '',//倒计时显示内容
      timer: null,
      loading:true,
      subFinishData:{
        userExamId: "",
        userAnswers:[],
      },
      dataList: [
        /*{
          questionType: 1,//单选题
          label: '一、单选题',
          subLabel: '（共5题目，每题10分，共50分）',
          questionList: [
            {
              question: '1.您认为自己的职业生涯中，您最关心的是什么？',
              answerList: [
                {
                  label: 'A.职业生涯的起点',
                  value: 'A'
                },
                {
                  label: 'B.职业生涯的终点',
                  value: 'B'
                },
                {
                  label: 'C.职业生涯的路径',
                  value: 'C'
                },
                {
                  label: 'D.职业生涯的目标',
                  value: 'D'
                }
              ],
              answer: 'A',
              selected: ''
            },
            {
              question: '2.您认为自己的职业生涯中，您最关心的是什么？',
              answerList: [
                {
                  label: 'A.职业生涯的起点',
                  value: 'A'
                },
                {
                  label: 'B.职业生涯的终点',
                  value: 'B'
                },
                {
                  label: 'C.职业生涯的路径',
                  value: 'C'
                },
                {
                  label: 'D.职业生涯的目标',
                  value: 'D'
                }
              ],
              answer: 'D',
              selected: ''
            }
          ],
        },
        {
          questionType: 2,//多选题
          label: '二、多选题',
          subLabel: '（共2题目，每题10分，共50分）',
          questionList: [
            {
              question: '1.您认为自己的职业生涯中，您最关心的是什么？',
              answerList: [
                {
                  label: 'A.职业生涯的起点',
                  value: 'A'
                },
                {
                  label: 'B.职业生涯的终点',
                  value: 'B'
                },
                {
                  label: 'C.职业生涯的路径',
                  value: 'C'
                },
                {
                  label: 'D.职业生涯的目标',
                  value: 'D'
                }
              ],
              answer: ['A', 'B'],
              selected: []
            },
            {
              question: '2.您认为自己的职业生涯中，您最关心的是什么？',
              answerList: [
                {
                  label: 'A.职业生涯的起点',
                  value: 'A'
                },
                {
                  label: 'B.职业生涯的终点',
                  value: 'B'
                },
                {
                  label: 'C.职业生涯的路径',
                  value: 'C'
                },
                {
                  label: 'D.职业生涯的目标',
                  value: 'D'
                }
              ],
              answer: ['A', 'C', 'D'],
              selected: []
            }
          ]
        },
        {
          questionType: 3,//判断题
          label: '三、判断题',
          subLabel: '（共1题目，每题10分，共50分）',
          questionList: [
            {
              question: '1.您认为自己的职业生涯中，您最关心的是什么？',
              answerList: [
                {
                  label: 'A.正确',
                  value: 'A'
                },
                {
                  label: 'B.错误',
                  value: 'B'
                },
              ],
              answer: 'A',
              selected: ''
            }
          ]
        },
        {
          questionType: 4,//填空题
          label: '四、填空题',
          subLabel: '（共2题目，每题10分，共50分）',
          questionList: [
            {
              question: '1、牙乳头可分化形成（ ）；',
              answer: [{label: '1', value: '牙齿'}],
              input: [{label: '1', value: ''}]
            },
            {
              question: '2、面瘫病人是否有膝状神经节受损尤应做（ ）和（ ）；',
              answer: [{label: '1', value: '牙齿'}, {label: '2', value: '牙床'}],
              input: [{label: '1', value: ''}, {label: '2', value: ''}]
            }
          ]
        }*/
      ],
      isSubmit: false,//是否已经交卷
      isPassed: false,//是否合格
    }
  },
  mounted() {
    // 在试卷数据渲染完成后调用倒计时初始化

  },
  created() {
    this.getExamQuestionData()
  },
  computed: {
    // 多选题的判断
    checkResult() {
      return function (val, val1) {
        return val.sort().toString() === val1.sort().toString()
      }
    },
    // 填空题的判断
          checkInput(val,val1) {
            return function (val, val1) {
              let res1 = []
              let res2 = []
              for (let i of val) {
                res1.push(i.value)
              }
              for (let i of val1) {
                res2.push(i.value)
              }
              return res1.join('、') === res2.join('、')
            }
          },
          //  我的填空回显
          myInput(val) {
            return function (val) {
              let res = []
              for (let i of val) {
                res.push(i.value)
        }
        return res.join('、')
      }
    },
    // 填空题答案回显
    inputAnswer(val) {
      return function (val) {
        let res = []
        for (let i of val) {
          res.push(i.value)
        }
        return res.join('、')
      }
    }
  },
  methods: {
    // 倒计时初始化
    initTimer() {
      this.$nextTick(() => {
        // 倒计时前先调用一次方法，解决卡顿一秒的问题
        this.countTime()
        // 开始倒计时
        this.timer = setInterval(this.countTime, 1000)
      })
    },
    getExamQuestionData(){
      this.loading=true
      getPaperQuestion(this.$route.query.paperId).then(res=>{
        this.paperQuestion=res;
        this.times=this.paperQuestion.duration*60
        this.subFinishData.userExamId=this.paperQuestion.userExamId
        this.subFinishData.totalScore=this.paperQuestion.totalScore
        this.subFinishData.passingScore=this.paperQuestion.passingScore
        this.dataList=this.paperQuestion.paperScoreQuestionList;
        this.loading=false
        this.dataList.forEach(item=>{
          item.questionList.forEach(question=>{
            if(question.questionType*1===2){
              question.chooseAnswer=[]
            }else {
              question.chooseAnswer=''
            }
            if(question.questionContent.indexOf("</p>")>0){
              question.questionContent=question.questionContent.replace("<p>","<span>")
              question.questionContent=question.questionContent.replace("</p>","</span>")
            }
            question.answerList.forEach(answer=>{
              if(answer.answerContent.indexOf("</p>")>0){
                answer.answerContent=answer.answerContent.replace("<p>","<span>")
                answer.answerContent=answer.answerContent.replace("</p>","</span>")
              }
            })
          })
          item.subLabel='（共'+item.number+'题目，每题'+item.eachScore+'分，共'+item.subtotal+'分）'

        })
        this.initTimer();
      })
    },
    // 倒计时
    countTime() {
      let h, hour, m, min, s, second
      if (this.times >= 0) {
        // 时
        h = Math.floor((this.times / 60 / 60) % 24);
        hour = h < 10 ? "0" + h : h;
        // 分
        m = Math.floor((this.times / 60) % 60);
        min = m < 10 ? "0" + m : m;
        // 秒
        s = Math.floor(this.times % 60);
        second = s < 10 ? "0" + s : s;
        this.times--
        this.timeMsg = hour + " : " + min + " : " + second
      } else {
        // 倒计时结束
        clearInterval(this.timer)
        this.doEnd()
      }
    },

    // 倒计时结束事件
    doEnd() {
      this.finishExam()
      // 显示超时弹窗
      this.$refs.popup.open()
    },
    finishExam(){
      this.subFinishData.userExamId=this.paperQuestion.userExamId
      this.subFinishData.userAnswers=[];
      this.dataList.forEach(item=>{
        item.questionList.forEach(question=>{
          debugger
          let chooseAnswer="";
          if(question.questionType*1===1||question.questionType*1===3){ //单选题，判断题
            chooseAnswer=question.chooseAnswer;
          }else if(question.questionType*1===2){ //多选题
            chooseAnswer=question.chooseAnswer.sort().toString();
          }else { //填空题
            let index=1;
            question.answerList.forEach(answer=>{
              if(answer.value){
                if(index===question.answerList.length){
                  chooseAnswer+=answer.value;
                }else {
                  chooseAnswer+=answer.value+",";
                }
                index++;
              }
            })
          }
          let userAnswer={
            examQuestionId:question.id,
            questionId:question.questionId,
            questionType:question.questionType,
            chooseAnswer:chooseAnswer,
            eachScore:item.eachScore
          }
          this.subFinishData.userAnswers.push(userAnswer);
        })
      })
      finishExam(this.subFinishData).then(res=>{
          this.subFinishData=res
          this.subFinishData.userAnswers.forEach(item=>{
            this.dataList.forEach(it=>{
              it.questionList.forEach(question=>{
                if(question.questionId===item.questionId){
                  question.rightAnswers=item.rightAnswers
                  question.isRight=item.isRight
                }
              })
            })
          })
        this.$router.push({
          name:'written-test-result',
          params: {
            "paperId":this.paperId,
            "score":this.subFinishData.score,
            duration:this.paperQuestion.duration,
            questionNum:this.paperQuestion.questionNum,
            totalScore:this.paperQuestion.totalScore,
            isPassed:this.subFinishData.isPassed,
            paperName:this.paperQuestion.paperName
          }
        })
        this.isSubmit=true
      })
    },
    /**
     * 提交试卷后，重新获取一次数据，刷新页面并且更新试卷状态，
     * 当前模拟的数据是带答案并且做了简单对错判断（填空部分对错应该用后端返回状态来判断），
     * 答案和对错的状态，应由后端处理后返回，回显部分应由对错的状态来判断，请根据实际数据调整
     */
    doSubmit(val) {
      switch (val) {
          // 交卷
        case 1:
          this.finishExam()
          break;
          //  查看证书
        case 2:
          this.showCert()
          break;
          //  重新做题
        case 3:
          this.getExamQuestionData()
          this.isSubmit = false
          this.isPassed = false
          break;
      }
    },
    showCert(){
      this.$router.push({
        name:"mine",
        query: {
          menuIndex:6,
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.test-paper {
  width: 820px;
}

.total-padding {
  padding: 0 30px 30px 30px;
  background: #fff;
}

::v-deep .el-input__inner {
  background: #f7f7f7;
  border: none;
}

.btn {
  background: #407aff;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  padding: 13px 114px;
  display: inline-block;
  margin: 50px auto;

  &:hover {
    background: rgba($color: #407aff, $alpha: 0.8);
    color: #fff;
    cursor: pointer;
    transition: all ease-in 0.2s;
  }
}

.answer-row {
  background: #f7f7f7;
  border-radius: 5px;
}

.right-part {
  width: 360px;

  .time-window {
    width: 360px;
    height: 455px;
    background-color: rgba(255, 255, 255, 0.20);
    border-radius: 5px;
    background-image: url("../../assets/examination/examination-count-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: fixed;
    right: 360px;
    top: 85px;
  }

  .count-icon {
    width: 28px;
    height: 28px;
  }

  .count-box {
    background: #f5f9fc;
    border-radius: 5px;
    margin: 0 40px;
    color: #407aff;
    font-weight: bold;
    letter-spacing: 2px;
    font-size: 24px;
    padding: 8px 0;
    text-align: center;
  }

  .str-line {
    width: 1px;
    height: 50px;
    background: #F7F7F7;
  }

  .warning-box {
    background: #fff4ef;
    border-radius: 5px;
    color: #FF5918;
    padding: 10px 17px;
  }
}

.res-icon{
  width: 70px;
  height: 70px;
  position: absolute;
  right: 34px;
  top: 0;
}

.warning-text{
  letter-spacing: 2px;
  line-height: 18px;
}
.el-radio,.el-checkbox{
  width: 100%;
}
.question-content>p{
  display: inline-block;
}
.el-radio__label p,el-checkbox__label p{
  display: inline-block;
}
</style>